import { lazy, Suspense } from 'react';
import { Navigate } from 'react-router';

import MOBILE_PATHS from 'mobile/paths';
import SentryErrorBoundary from '../SentryErrorBoundary';

const MobileShellLayout = lazy(() => import('mobile/MobileApp'));
const Home = lazy(() => import('mobile/screens/Home'));
const Recording = lazy(() => import('mobile/screens/Recording'));
const Finish = lazy(() => import('mobile/screens/Finish'));
const Sessions = lazy(() => import('mobile/screens/Sessions'));
const CreateRespondent = lazy(() => import('mobile/screens/CreateRespondent'));

const { home, recording, finish, sessions, createRespondent } = MOBILE_PATHS;

const MobileRoutes = {
  path: '/',
  element: (
    <Suspense fallback={null}>
      <MobileShellLayout />
    </Suspense>
  ),
  errorElement: <SentryErrorBoundary />,
  children: [
    { path: home, element: <Home /> },
    { path: recording, element: <Recording /> },
    { path: finish, element: <Finish /> },
    { path: sessions, element: <Sessions /> },
    { path: createRespondent, element: <CreateRespondent /> },
    { path: '*', element: <Navigate to={home} replace /> }
  ]
};

export default MobileRoutes;
